'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeskproWindowFacade = exports.DeskproWindowEvents = undefined;
exports.createDeskproWindowFacade = createDeskproWindowFacade;
exports.registerEventHandlers = registerEventHandlers;

var _EventHandler = require('../Core/EventHandler');

var _events = require('./events');

var DeskproWindowEvents = _interopRequireWildcard(_events);

var _DeskproWindowFacade = require('./DeskproWindowFacade');

var _DeskproWindowFacade2 = _interopRequireDefault(_DeskproWindowFacade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @function
 * @param {AppEventEmitter} eventDispatcher
 * @returns {DeskproWindowFacade}
 */
function createDeskproWindowFacade(eventDispatcher) {
  "use strict";

  return new _DeskproWindowFacade2.default(eventDispatcher);
}

/**
 * Registers helpdesk window events with the event dispatching system
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
/**
 * This module exports the interface of the DeskproWindow package
 *
 * @module DeskproWindow
 */

function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, DeskproWindowEvents.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION, DeskproWindowEvents.props.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, DeskproWindowEvents.EVENT_DESKPROWINDOW_DOM_INSERT, DeskproWindowEvents.props.EVENT_DESKPROWINDOW_DOM_INSERT);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, DeskproWindowEvents.EVENT_DESKPROWINDOW_DOM_QUERY, DeskproWindowEvents.props.EVENT_DESKPROWINDOW_DOM_QUERY);
}

exports.DeskproWindowEvents = DeskproWindowEvents;
exports.DeskproWindowFacade = _DeskproWindowFacade2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/DeskproWindow/index.js
// module id = 107
// module chunks = 0